import { render, staticRenderFns } from "./MicrosoftSignIn.vue?vue&type=template&id=22ad2dc7&scoped=true&"
import script from "./MicrosoftSignIn.vue?vue&type=script&lang=ts&"
export * from "./MicrosoftSignIn.vue?vue&type=script&lang=ts&"
import style0 from "./MicrosoftSignIn.vue?vue&type=style&index=0&id=22ad2dc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ad2dc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22ad2dc7')) {
      api.createRecord('22ad2dc7', component.options)
    } else {
      api.reload('22ad2dc7', component.options)
    }
    module.hot.accept("./MicrosoftSignIn.vue?vue&type=template&id=22ad2dc7&scoped=true&", function () {
      api.rerender('22ad2dc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/auth/MicrosoftSignIn.vue"
export default component.exports